import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type GetExternalTrainingModuleVersionsResponse = {
   imports: {
      external_training_module_importid: number;
      rustici_version_number: number;
   }[];
};

export async function getExternalTrainingModuleVersions(
   external_training_moduleid: number,
   { ...common }: CommonRequestOptions = {}
): Promise<GetExternalTrainingModuleVersionsResponse> {
   return makeRequest('get', `/external_training_modules/${external_training_moduleid}/imports`, {
      ...common,
   });
}
